import { render, staticRenderFns } from "./ProductGroupSelectAutocomplete.vue?vue&type=template&id=109aa0d2&scoped=true"
import script from "./ProductGroupSelectAutocomplete.vue?vue&type=script&lang=ts"
export * from "./ProductGroupSelectAutocomplete.vue?vue&type=script&lang=ts"
import style0 from "./ProductGroupSelectAutocomplete.vue?vue&type=style&index=0&id=109aa0d2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "109aa0d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('109aa0d2')) {
      api.createRecord('109aa0d2', component.options)
    } else {
      api.reload('109aa0d2', component.options)
    }
    module.hot.accept("./ProductGroupSelectAutocomplete.vue?vue&type=template&id=109aa0d2&scoped=true", function () {
      api.rerender('109aa0d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/product-group/ProductGroupSelectAutocomplete.vue"
export default component.exports